<div class="container">
    <div class="centered-content">
        <!-- <span style="color: #1650b1;font-weight: 500;">Card Size : 350px * 500px</span><br> -->
        <span style="color: #1650b1;font-weight: 500;">Card Size : 350px * 500px</span><br>
        <p style="color: #1650b1;font-weight: 500;">Image Size : 350px * 180px</p>
        <div class="card " [ngClass]="{'selected': isSelected}">
            <div class="img-background">
                <img class="card-image" *ngIf="image" [src]="image" (error)=" onImageError($event)"
                    alt="Uploaded Image">
            </div>
            <img id="image_path" class="card-img" src='https://aieventzo.com/upload/user.png'>

            <div class=" card-body">
                <!-- <div class="row" style="margin-bottom: -30px;text-transform: capitalize;font-weight: 700;">
                    <p class="card-title fullname">Participant Name </p>&nbsp;
                </div> -->
                <div class="row">
                    <div>Registration ID</div>
                </div>
                <div class="row">
                    <div class="mobile">Name</div>
                </div>
                <div class="row">
                    <div class="city">Mobile</div>
                </div>
                <div class="row">
                    <div class="city">City</div>
                </div>
                <div class="row">
                    <div class="city">Event Type</div>
                </div>
                <div style="display: flex;justify-content: center;margin-top: 5px;">
                    <img src="./assets/qrcode.png" style="height: 100px;width: 100px;" alt="">
                </div>
            </div>
        </div>
    </div>
</div>